import React, { useState } from "react";
import { ChevronDown, LogOut, Settings } from "lucide-react";
import { getGreeting } from "../../utils/getGreeting";
import { useAuth } from "../../context/AuthContext";

const Topbar: React.FC = () => {
  const greeting = getGreeting();
  const { user, logout } = useAuth();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  return (
    <div className="h-16 bg-white shadow-sm w-full p-4 flex justify-between fixed top-0 left-0 z-10 border-b">
      <div className="font-bold text-2xl relative">
        <div>
          Airconnect<span className="text-blue-500">travel</span>
        </div>
        <span className="text-sm absolute top-[-35%] right-0">admin</span>
      </div>
      <div className="inline-flex space-x-2 items-center justify-evenly border-l px-2 w-[150px] relative">
        <div>
          <div className="font-bold text-xs whitespace-nowrap">{greeting}</div>
          <div className="font-bold text-sm whitespace-nowrap">
            {user?.name || "Admin(N/A)"}
          </div>
        </div>
        <button
          onClick={toggleDropdown}
          className="flex items-center space-x-1"
        >
          <ChevronDown
            size={20}
            className={`transition-transform duration-200 ${
              isDropdownOpen ? "rotate-180" : ""
            }`}
          />
        </button>

        {isDropdownOpen && (
          <div className="absolute top-[100%] right-0 mt-2 w-48 bg-white rounded-md overflow-hidden shadow-xl z-10">
            <a
              href="/settings"
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"
            >
              <Settings size={18} className="mr-2" />
              Settings
            </a>
            <button
              onClick={logout}
              className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"
            >
              <LogOut size={18} className="mr-2" />
              Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Topbar;
